import React, { useState, useEffect } from "react";
import {
    Button,
    InputGroup,
    Dropdown,
    DropdownButton,
    Form,
    Accordion,
    Tabs,
    Tab,
    Row,
    Col,
} from "react-bootstrap";
import { CREATE_FORM_APPLICATION_URL, FORM_BUILDER_AUTOSEARCH_EVENT_URL, FORM_BUILDER_AUTOSEARCH_URL, FORM_BUILDER_FORM_AUTO_SAVE_URL, VIEW_SETTING_URL } from "../../../../Constant/api";
import { authService } from "../../../../Service/Axios";
import {
    nameRegex,
    alphanumericRegex,
    numericRegex,
} from "../../../../Utils/regex";
import { toast } from "react-toastify";

const AutoComplete = ({
    status,
    setsettings,
    eleavailable,
    viewForm,
    setviewSetting,
    settings,
    seteleavailable,
    allElements,
    formId,
    setfirst,
    first,
    setviewForm,
    dynaDDselarr,
    viewFormAction,
    drop
}) => {
    const [inpValue, setinpValue] = useState(
        viewForm[0]?.value.length > 0
            ? viewForm[0].value[0]
            : ""
    );

    useEffect(() => {
        setinpValue(viewForm[0]?.value.length > 0
            ? viewForm[0].value[0]
            : "")
    }, [viewForm[0]?.value?.length], [first])

    useEffect(() => {
        setinpValue(viewForm[0]?.value.length > 0
            ? viewForm[0].value[0]
            : "")
    }, viewForm[0]?.value, [first])

    const [flagAc, setflagAc] = useState(null);

    useEffect(() => {
        if (!settings) setflagAc(null)
    }, [settings])

    const handleDelete = (ID) => {
        seteleavailable(allElements.filter((item) => item.questionId != ID));
    };

    const handleSetting = () => {
        // setopenset(k)
        viewSettingAction();
    };

    const viewSettingAction = async () => {
        const payload = {
            formId: formId,
            questionId: eleavailable[0]?.questionId,
            elementType: eleavailable[0]?.typename,
            sequenceNo: eleavailable[0]?.sequenceNo,
        };
        const response = await authService(VIEW_SETTING_URL, "POST", payload);
        if (response) {
            setviewSetting(response);
        }
        setsettings(!settings);
    };

    const [autoSearch, setautoSearch] = useState([]);

    const getautoSearch = async (value) => {
        setinpValue(viewForm[0].maximumLength > 0 ? value.slice(0, viewForm[0].maximumLength) : value);

        const payload = {
            searchtext: value,
            limit: 10,
            autoSearchName: viewForm[0]?.autoSearch

        };
        const response = await authService(
            FORM_BUILDER_AUTOSEARCH_URL,
            "POST",
            payload
        );
        setautoSearch(response);
    };

    const [tempJSX, settempJSX] = useState({
        maxi: "",
        mini: "",
        alphab: "",
        alphanum: "",
    });

    const postautoSearch = async (data, value, random) => {
        const payload = {
            formId: formId,
            questionId: viewForm[0]?.questionId,
            gid: value,
            autoSearchName: viewForm[0]?.autoSearch,
            appId: dynaDDselarr?.appId,
            value: random,
            urlParameter: drop
        }
        const payload1 = {
            formId: formId,
            fieldDetails: data,
            appId: dynaDDselarr?.appId,
        };
        const response1 = await authService(
            FORM_BUILDER_FORM_AUTO_SAVE_URL,
            "POST",
            payload1
        );
        if (response1) {
            payload.appId = response1.appId;
        }
        var millisecondsToWait = 500;
        setTimeout(function () {
            // Whatever you want to do after the wait
        }, millisecondsToWait);
        const response = await authService(
            FORM_BUILDER_AUTOSEARCH_EVENT_URL,
            "POST",
            payload
        );
        if (response) {
            // setappID(response.appId)
            setviewForm(response);
            let temp = [];
            response?.pages?.forEach((i) => {
                i?.sections?.forEach((el) => {
                    el?.questions?.forEach((item) => {
                        temp.push({
                            sectionId: item?.sectionId,
                            questionId: item?.questionId,
                            value: item?.value,
                            choiceGroupKeyValue: item?.choiceGroupKeyValue,
                        });
                    });
                });
            });
            setfirst(temp);
        }
        // viewFormAction()
    };

    const autoSaveForm = async (data, id) => {
        const payload = {
            formId: formId,
            fieldDetails: data,
            appId: id,
        };
        const response = await authService(
            FORM_BUILDER_FORM_AUTO_SAVE_URL,
            "POST",
            payload
        );

    };

    const handleinpChange = (val, d) => {

        setinpValue(viewForm[0].maximumLength > 0 ? val.slice(0, viewForm[0].maximumLength) : val);

        let maxi = "",
            mini = "",
            alphab = "",
            alphanum = ""

        if (
            viewForm[0].maximumLength > 0 &&
            val.length > viewForm[0].maximumLength
        ) {

            maxi = `Maximum Length is ${viewForm[0]?.maximumLength}`

        }
        else {
            maxi = ""
        }

        if (
            viewForm[0].minimumLength > 0 &&
            val.length < viewForm[0].minimumLength
        ) {

            mini = `Minimum Length is ${viewForm[0]?.minimumLength}`

        }
        else {
            mini = ""
        }

        if (viewForm[0]?.dropdownapi == "Alphabet") {
            if (!nameRegex.test(val)) {
                alphab = "Only Alphabet here"
            }
            else {
                alphab = ""
            }
        }
        if (viewForm[0]?.dropdownapi == "Alphanumeric") {
            if (!alphanumericRegex.test(val)) { alphanum = "Only Alphanumeric here" }
            else {
                alphanum = ""
            }
        }

        settempJSX({
            maxi: maxi,
            mini: mini,
            alphab: alphab,
            alphanum: alphanum,
        })

        setviewForm({
            formId: dynaDDselarr?.formId,
            formName: dynaDDselarr?.formName,
            description: dynaDDselarr?.description,
            status: dynaDDselarr?.status,
            pages: dynaDDselarr?.pages.map((item) => {
                return {
                    ...item,
                    sections: item.sections.map((i) => {
                        return {
                            sectionId: i.sectionId,
                            name: i.name,
                            label: i.label,
                            description: i.description,
                            questions: i?.questions?.map((item) => {
                                if (item.questionId == viewForm[0]?.questionId) {
                                    item = { ...item, value: [viewForm[0].maximumLength > 0 ? val.slice(0, viewForm[0].maximumLength) : val] };
                                }
                                return item;
                            }),
                            rules: i.rules,
                            type: i.type,
                            addrule: i.addrule,
                            show: i.show,
                            mainConditions: i.mainConditions,
                            sectionDescription: i.sectionDescription,
                        };
                    }),
                };
            }),
        });

        setTimeout(() => {
            autoSaveForm(first.map((item) => {
                if (item.questionId == viewForm[0]?.questionId) {
                    item = {
                        ...item,
                        value: [viewForm[0].maximumLength > 0 ? val.slice(0, viewForm[0].maximumLength) : val],
                    };
                }
                return item;
            }), dynaDDselarr?.appId)
        }, 5000)

        postautoSearch(
            first.map((item) => {
                if (item.questionId == viewForm[0]?.questionId) {
                    item = {
                        ...item,
                        value: [viewForm[0].maximumLength > 0 ? val.slice(0, viewForm[0].maximumLength) : val],
                    };
                }
                return item;
            }),

            d, viewForm[0].maximumLength > 0 ? val.slice(0, viewForm[0].maximumLength) : val)

        setautoSearch([])
    }

    return (
        <Col className="mt-2 mb-2"
            xxl={
                eleavailable[0]?.columnSpan == 1
                    ? 12
                    : viewForm[0]?.columnSpan == 1 &&
                        eleavailable[0]?.columnSpan != 1 &&
                        !settings
                        ? 12
                        : viewForm[0]?.columnSpan == 1 &&
                            eleavailable[0]?.columnSpan == 1 &&
                            settings
                            ? 12
                            : 6
            }
            xl={
                eleavailable[0]?.columnSpan == 1
                    ? 12
                    : viewForm[0]?.columnSpan == 1 &&
                        eleavailable[0]?.columnSpan != 1 &&
                        !settings
                        ? 12
                        : viewForm[0]?.columnSpan == 1 &&
                            eleavailable[0]?.columnSpan == 1 &&
                            settings
                            ? 12
                            : status == "save" ? 12 : 6
            }
            lg={12}
            md={12}
            sm={12}
            xs={12}
        >
            <div
                className={`${(status == `preview` ||
                    status == `In Progress` ||
                    status == `Submitted` ||
                    status == "Published") && !viewForm[0]?.internal
                    ? `builder-row border rounded-2 bg-light preview-field`
                    : (status == `preview` ||
                        status == `In Progress` ||
                        status == `Submitted` ||
                        status == "Published") && viewForm[0]?.internal ?
                        `builder-row border rounded-2 bg-light preview-field d-none`
                        : flagAc == eleavailable[0]?.questionId ? `builder-row border rounded-2 bg-light active` : `builder-row border rounded-2 bg-light`
                    }`}
            >
                <div className="builder-row-header py-2 px-3 border-bottom d-flex">
                    <h4>
                        <span className="material-symbols-outlined align-middle me-2">
                            fact_check
                        </span>{" "}
                        Auto Complete
                    </h4>
                    <div className="button-list ms-auto d-flex">
                        <Button variant="transparent">
                            <span
                                className="material-symbols-outlined align-middle copy-btn me-2"
                                onClick={(e) => { setflagAc(eleavailable[0]?.questionId); handleSetting(); }}
                            >
                                settings
                            </span>
                        </Button>
                        <Button variant="transparent">
                            <span
                                className="material-symbols-outlined align-middle remove-btn"
                                onClick={(e) => handleDelete(eleavailable[0]?.questionId)}
                            >
                                delete
                            </span>
                        </Button>
                    </div>
                </div>
                <div className="builder-row-body d-flex flex-wrap">
                    <div className="drag-btn d-flex justify-content-center align-items-center border-end">
                        <Button variant="transparent">
                            <span className="material-symbols-outlined">drag_indicator</span>
                        </Button>
                    </div>
                    <div className="builder-field p-3">
                        <Form.Group className="mb-3 position-relative" controlId="shorttext">
                            <Form.Label>
                                {eleavailable[0]?.label.length > 0
                                    ? eleavailable[0].label
                                    : viewForm[0]?.label.length > 0
                                        ? viewForm[0]?.label
                                        : "Add your question here"}{" "}
                                {eleavailable[0]?.required ? (
                                    <span className="text-danger"> *</span>
                                ) : viewForm[0]?.required &&
                                    !eleavailable[0]?.required &&
                                    !settings ? (
                                    <span className="text-danger"> *</span>
                                ) : viewForm[0]?.required &&
                                    eleavailable[0]?.required &&
                                    settings ? (
                                    <span className="text-danger"> *</span>
                                ) : (
                                    <span></span>
                                )}
                                <small className="d-block">
                                    {eleavailable[0]?.fieldDescription.length > 0
                                        ? eleavailable[0].fieldDescription
                                        : viewForm[0]?.fieldDescription}
                                </small>
                            </Form.Label>
                            {status == "preview" ||
                                status == "In Progress" ||
                                status == `Submitted` ||
                                status == "Published" ? (
                                <Form.Control
                                    className={`${tempJSX.mini.length > 0 ||
                                        tempJSX.maxi.length > 0 ||
                                        tempJSX.alphab.length > 0 ||
                                        tempJSX.alphanum.length > 0 ||
                                        (eleavailable[0]?.required
                                            ? eleavailable[0].required
                                            : viewForm[0]?.required && inpValue?.length <= 0 && dynaDDselarr?.mandatory)
                                        ? `is-invalid`
                                        : ``
                                        }`}
                                    style={dynaDDselarr?.status == "Submitted" ? { pointerEvents: "none" } : {}}
                                    value={inpValue}
                                    onChange={(e) => getautoSearch(e.target.value)}
                                    disabled={
                                        eleavailable[0]?.hidden
                                            ? true
                                            : viewForm[0]?.hidden &&
                                                !eleavailable[0]?.hidden &&
                                                !settings
                                                ? true
                                                : viewForm[0]?.hidden &&
                                                    eleavailable[0]?.hidden &&
                                                    settings
                                                    ? true
                                                    : false
                                    }
                                    type="text"
                                    placeholder={
                                        eleavailable[0]?.placeholderText.length > 0
                                            ? eleavailable[0].placeholderText
                                            : viewForm[0]?.placeholderText
                                    }
                                    required={
                                        eleavailable[0]?.required
                                            ? true
                                            : viewForm[0]?.required &&
                                                !eleavailable[0]?.required &&
                                                !settings
                                                ? true
                                                : viewForm[0]?.required &&
                                                    eleavailable[0]?.required &&
                                                    settings
                                                    ? true
                                                    : false
                                    }
                                />
                            ) : (
                                <Form.Control
                                    className={`${tempJSX.mini.length > 0 ||
                                        tempJSX.maxi.length > 0 ||
                                        tempJSX.alphab.length > 0 ||
                                        tempJSX.alphanum.length > 0 ||
                                        (eleavailable[0]?.required
                                            ? eleavailable[0].required
                                            : viewForm[0]?.required && inpValue?.length <= 0 && dynaDDselarr?.mandatory)
                                        ? `is-invalid`
                                        : ``
                                        }`}
                                    value={inpValue}
                                    readOnly
                                    disabled={
                                        eleavailable[0]?.hidden
                                            ? true
                                            : viewForm[0]?.hidden &&
                                                !eleavailable[0]?.hidden &&
                                                !settings
                                                ? true
                                                : viewForm[0]?.hidden &&
                                                    eleavailable[0]?.hidden &&
                                                    settings
                                                    ? true
                                                    : false
                                    }
                                    type="text"
                                    placeholder={
                                        eleavailable[0]?.placeholderText.length > 0
                                            ? eleavailable[0].placeholderText
                                            : viewForm[0]?.placeholderText
                                    }
                                />
                            )}
                            {autoSearch && autoSearch.length > 0 && (
                                <ul className="institution-list z-10 w-100 max-w-100">
                                    {autoSearch.map((inst) => (
                                        <li key={inst.gid}>
                                            <a onClick={() => handleinpChange(inst.name, inst.gid)}>
                                                {inst.name}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            )}
                            {tempJSX.mini.length > 0 && (
                                <small className="text-danger">
                                    {tempJSX.mini}
                                    <br />
                                </small>
                            )}
                            {tempJSX.maxi.length > 0 && (
                                <small className="text-danger">
                                    {tempJSX.maxi}
                                    <br />
                                </small>
                            )}
                            {tempJSX.alphab.length > 0 && (
                                <small className="text-danger">
                                    {tempJSX.alphab}
                                    <br />
                                </small>
                            )}
                            {tempJSX.alphanum.length > 0 && (
                                <small className="text-danger">
                                    {tempJSX.alphanum}
                                    <br />
                                </small>
                            )}
                        </Form.Group>
                    </div>
                </div>
            </div>
        </Col>
    );
};

export default AutoComplete;
